<template>
  <v-row justify="center" align="center" style="height: 70vh">
    <v-col cols="10">
      <div class="text-center mb-10">
        <div class="text-h4">¡Hola! Antes que nada contanos,</div>
        <div class="text-h4 mt-3">¿qué vas a registrar?</div>
      </div>

      <v-row justify="center" align="stretch" dense>
        <!-- Producto de catálogo -->
        <v-col cols="12" md="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="d-flex flex-column align-center justify-center pa-6"
              :elevation="hover ? 12 : 4"
              :color="hover ? 'grey darken-3' : ''"
              style="cursor: pointer; height: 100%"
              @click="
                $router.push({ name: 'admin.productosRegistrar.buscar' })
              "
            >
              <v-icon size="48" color="blue">mdi-cart</v-icon>
              <h3 class="mt-3">Producto de Catálogo</h3>
              <p class="text-subtitle-2 text-center" style="color: #bdbdbd">
                Producto tangible, comprado a proveedor (ej. alfajor, bebida,
                snack)
              </p>
            </v-card>
          </v-hover>
        </v-col>

        <!-- Producto de producción propia -->
        <v-col cols="12" md="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="d-flex flex-column align-center justify-center pa-6"
              :elevation="hover ? 12 : 4"
              :color="hover ? 'grey darken-3' : ''"
              style="cursor: pointer; height: 100%"
            >
              <v-icon size="48" color="green">mdi-factory</v-icon>
              <h3 class="mt-3">Producto de Producción</h3>
              <p class="text-subtitle-2 text-center" style="color: #bdbdbd">
                Producto fabricado por tu empresa, como panificados, comidas,
                etc.
              </p>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>